export default __webpack_public_path__ + "static/media/logo-small.aaf9a4d9.svg";